import { Component, OnDestroy, OnInit } from '@angular/core';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { Subscription } from 'rxjs';
import { ICheckFilter } from 'src/app/modules/core/interfaces/check-filter';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { Logger } from '../../../../../../projects/common/src/app/classes/logger';
import { excelExportDateFormat } from '../../../../../../projects/common/src/app/services/utils/util.service';
import { ReportService } from '../../services/report.service';
import { CacheService } from 'projects/common/src/app/services';

@Component({
  selector: 'app-report-machine-status',
  templateUrl: './report-machine-status.component.html',
  styleUrls: ['./report-machine-status.component.scss'],
})
export class ReportMachineStatusComponent extends Logger implements OnInit, OnDestroy {
  private subReportStatus: Subscription;
  public reportStatus: any;
  public filterConfig: IFilterConfig;

  public canDownload: boolean;
  public hideReport: boolean;
  public message: string;

  public showFilter: ICheckFilter;
  public selectedFilters: IOutputFilter;
  public systemError: string;

  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private langService: LanguageService,
    private layoutConfigService: LayoutConfigService,
    private reportService: ReportService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
    private cacheService: CacheService,
  ) {
    super();
    this.canDownload = false;
    this.hideReport = true;
    this.message = this.langService.message('select_type_machine_and_filter');

    this.filterConfig = {
      dates: { required: true, options: { daysRange: 30, minDayRange: 30 } },
      shift: { required: true },
      machineType: { required: true },
      mine: { required: true },
      machineList: { required: true, multiselect: true, dependsOn: ['mine'] },
      cleanButton: true,
    };
    this.disabledExcelBtn = false;
  }

  /**
   * Init component
   */
  public ngOnInit(): void {
    this.setHeader();
  }

  /**
   * Set titles of headers
   */
  private setHeader(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'rpt_machine_status',
      imageKey: 'report',
      imageType: 'section',
    };

    this.layoutConfigService.setConfig(config);
  }

  /**
   * Get report data from Api
   */
  public search(selectedFilters: IOutputFilter): void {
    const companyId = this.cacheService.local('session').user.company.id;
    this.selectedFilters = {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: selectedFilters.shiftId,
      machineTypeId: selectedFilters.machineTypeId,
      mineId: selectedFilters.zoneId,
      companyId,
      machineList: selectedFilters.machineId,
    };
    this.canDownload = false;
    this.filterConfig.isLoading = true;

    this.subReportStatus = this.reportService.getStatusMachineReport(this.selectedFilters).subscribe(
      (data) => {
        this.reportStatus = data.data;
        this.canDownload = true;

        // visibility report - now also check reportByMachineStatusFamily since machineList is deprecated
        const hasReportData =
          this.reportStatus?.reportByAllStatus?.length > 0 || this.reportStatus?.reportByMachineStatusFamily?.length > 0;

        if (hasReportData) {
          this.message = '';
          this.hideReport = false;
          this.btnSpinner = false;
          this.disabledExcelBtn = false;
        } else {
          this.hideReport = true;
          this.message = this.langService.message('m034');
          this.btnSpinner = false;
          this.disabledExcelBtn = true;
        }
        this.systemError = '';
        this.filterConfig.isLoading = false;
      },
      ({ name }) => {
        this.canDownload = false;
        this.hideReport = true;
        this.message = '';
        this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
        this.filterConfig.isLoading = false;
        this.btnSpinner = false;
        this.disabledExcelBtn = true;
      },
    );
    const filters = {
      reports: 'report-machine-status',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * Executes excel download
   */
  public downloadExcel(): void {
    const selectRangeDate = {
      startDate: excelExportDateFormat(this.selectedFilters.startDate),
      endDate: excelExportDateFormat(this.selectedFilters.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportService.getStatusMachineReportExcel(this.selectedFilters).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'rpt_machine_status', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }

  /**
   * Destroy component
   */
  public ngOnDestroy(): void {
    if (this.subReportStatus) {
      this.subReportStatus.unsubscribe();
    }
  }
}
